import { useAuth } from '@warden-ui/common';
import { parseQueryString, parseAmplifyConfig } from '@warden-ui/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CPPageBody } from '@warden-ui/common-components';
import { CardContentUserJoin } from '@warden-ui/card-components';
import { CupixWorksApi } from "@warden-ui/api";
import { CupixWorksDomainPostfix } from '@warden-ui/common';
import { useTranslation } from 'react-i18next';

const defaultQueryString: { [key: string]: string } = {
  team_name: '',
  team_domain: '',
  skip_signup: 'false',
};

export default function UserJoin() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [teamDomain, setTeamDomain] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cupixWorksApiEndpoint =
      amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      return;
    }

    setTeamDomain(
      `${queryString.team_domain}${CupixWorksDomainPostfix(
        cupixWorksApiEndpoint,
      )}`,
    );
  }, []);

  const redirectTo = () => {
    console.info(`User joined: ${queryString.email}`);

    window.location.replace(queryString.redirect_url);
  };

  const onClickResetPassword = async (
    firstname: string,
    lastname: string,
    password: string | undefined,
  ) => {
    const cupixWorksApiEndpoint =
      amplifyConfig[amplifyConfig.region]?.cupixworksApiEndpoint;
    if (!cupixWorksApiEndpoint) {
      setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      return;
    }

    setLoading(true);
    new CupixWorksApi(cupixWorksApiEndpoint)
      .teamSignup(
        queryString.team_domain,
        queryString.confirmation_token,
        queryString.email,
        firstname,
        lastname,
        password,
      )
      .then((userSession) => {
        return redirectTo();
      })
      .catch((error) => {
        console.error(error.message);
        setErrorMessage(t('errors.config_cupixworks_api_endpoint'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CPPageBody onBackClicked={() => navigate(-1)}>
      <CardContentUserJoin
        teamName={queryString.team_name}
        teamDomain={teamDomain}
        skipSignup={queryString.skip_signup}
        errorMessage={errorMessage}
        loading={loading}
        onClickResetPassword={onClickResetPassword}
      />
    </CPPageBody>
  );
}
